export enum DESIGN_SIZE {
  DEFAULT,
  HERO,
  SLIDER,
}
